const filters = [
    {
        name: 'inboxTypeFilter',
    },

    {
        name: 'OwnedByFilter',
        config: {
            protectdSubcomponent: 'RTA-CSVInbox-UploadedBy-Control', //This is the subcomponent that protects the Owned By filter, we dont wanna hide the filter completely but we wanna hide the optons to select the owner
        },
    },

    {
        name: 'inboxCategoryFilter',
    },
    {
        name: 'uploadedBeforeFilter',
        config: {
            label: 'UploadedBefore',
            contextProp: 'uploadedBefore',
        },
    },
    {
        name: 'uploadedAfterFilter',
        config: {
            label: 'UploadedAfter',
            contextProp: 'uploadedAfter',
        },
    },
    {
        name: 'textFilter',
        config: {
            label: 'TrackingID',
            contextProp: 'trackingID',
        },
    },
]

const csvInboxConfig = {
    filters: filters,
}

export default csvInboxConfig
